import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { useTheme } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import Badge from '@material-ui/core/Badge';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import Divider from '@material-ui/core/Divider';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import Paper from '@material-ui/core/Paper';
import Skeleton from '@material-ui/lab/Skeleton';
import Typography from '@material-ui/core/Typography';

import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import SearchIcon from '@material-ui/icons/Search';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import ClearIcon from '@material-ui/icons/Clear';

import * as math from '_core/utils/math';
import * as search from '_core/utils/search';
import * as api from '_core/utils/api';


const DATE_DISPLAY_FORMAT = 'D MMMM YYYY';
//const DATE_INPUT_FORMAT = 'D MMMM YYYY';
const DATE_EXPORT_FORMAT = 'YYYY-MM-DD';


export const DateValue = React.memo((props) => {
  const {
    l,
    
    column,
    data
  } = props;
  
  
  const value = math.getField(data, column.nameSplit[0]);
  
  return value === undefined ? '-' : moment(value).format(DATE_DISPLAY_FORMAT);
});

export const DateFilter = React.memo((props) => null);

export const getDateApiParam = (column, value) => {
  return value.getTime();
};

export const getDateExportValue = async (props, column, data) => {
  const value = math.getField(data, column.nameSplit[0]);
  
  return value === undefined ? '-' : moment(value).format(DATE_EXPORT_FORMAT);
};
